/* eslint-disable react/no-multi-comp, react/prop-types */
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';

import { CardHeader } from 'components/content-containers/cards';

import { Icon, PurchaseOrderActions } from './purchase-card-header-components';


export default function PurchaseCardHeader({ purchaseOrder, edit }) {
  const { unbilledQuantity, unapprovedExpenseBills, ticket, createdBy } = purchaseOrder;
  const cardHeaderClasses = classNames('purchase-card-header', {
    'purchase-order-unassigned': _.isEmpty(createdBy) || _.isEmpty(ticket),
    'expenses-all-approved': !unapprovedExpenseBills && unbilledQuantity === 0,
    archived: purchaseOrder.status === 'Archived'
  });

  return (
    <CardHeader className={cardHeaderClasses}>
      <div>
        <Icon {..._.pick(purchaseOrder, ['quantity', 'unbilledQuantity', 'unapprovedExpenseBills', 'status'])} />
        <span className="margin-left">{purchaseOrder.purchaseOrderNumber}</span>
        <span className="margin-left purchase-status">{getError(purchaseOrder)}</span>
      </div>
      { purchaseOrder.status !== 'Archived' &&
        <PurchaseOrderActions purchaseOrder={purchaseOrder} edit={edit} />
      }
    </CardHeader>
  );
}

PurchaseCardHeader.propTypes = {
  purchaseOrder: PropTypes.object.isRequired,
  edit: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.bool
  ])
};


// Internal function
function getError(purchaseOrder) {
  if (purchaseOrder.status === 'Archived') {
    return 'Deleted';
  } else if (_.isEmpty(purchaseOrder.createdBy) && _.isEmpty(purchaseOrder.ticket)) {
    return 'This purchase order is unassigned and doesn\'t have a ticket';
  } else if (_.isEmpty(purchaseOrder.createdBy)) {
    return 'This purchase order is unassigned';
  } else if (_.isEmpty(purchaseOrder.ticket)) {
    return 'This purchase order doesn\'t have a ticket';
  }
}
